<template>
    <!-- normally UIkit is used in insights but the UIkit style is not loaded where modals are placed -->
    <b-modal :id="`modal${graphId}`">
        <template #modal-title>
            {{ title }}
        </template>
        <p>{{ description }}</p>
    </b-modal>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "GraphModal",
    props: {
        graphId: {
            required: true,
            type: Number,
        },
        title: {
            required: true,
            type: String,
        },
        description: {
            required: true,
            type: String,
        },
    },
});
</script>
